import { Validators } from '@angular/forms';
import { FieldsOptions } from '@sim/form';
import { FilterFieldsOptions } from '@src/app/ui/ui.module';

export enum CollectionStatus {
  Draft = 'draft',
  Private = 'private',
}

export type CollectionClassName =
  'BeneOA' |
  'BeneS' |
  'BeneF' |
  'BeneD' |
  'BeneMI' |
  'DocumentoArc' |
  'DocumentoBib' |
  'Base' |
  'Collezione' |
  'OggettoCollezione';

export interface Collection {
  id: string;
  codiceUnico: string;
  titolo: string;
  descrizione: string;
  status: CollectionStatus;
  user: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface CollectionFilter {
  descrizione?: string;
  titolo?: string;
}

export const CollectionFilterMeta: FilterFieldsOptions<CollectionFilter> = {
  descrizione: { operator: 'contains' },
  titolo: { operator: 'begins_with' },
};

export interface CollectionItem {
  id: string;
  className: CollectionClassName;
  /** Id reference to the entity */
  objectId: string;
  titolo: string;
  descrizione: string | null;
  collezioni: Collection[];
  file: string | null;
  previewUrl: string | null;
}

export const CollectionMeta: FieldsOptions<Collection> = {
  descrizione: { value: '' },
  id: {},
  titolo: { value: '', validators: [Validators.required] },
};

export const CollectionItemaMeta: FieldsOptions<CollectionItem> = {
  className: { value: '', validators: [Validators.required] },
  descrizione: { value: '' },
  id: {},
  objectId: { validators: [Validators.required] },
  titolo: { value: '', validators: [Validators.required] },
};

export interface CollectionItemFilter {
  className?: CollectionClassName;
  descrizione?: string;
  titolo?: string;
}

export const CollectionItemFilterMeta: FilterFieldsOptions<CollectionItemFilter> = {
  className: { operator: 'equal' },
  descrizione: { operator: 'contains' },
  titolo: { operator: 'begins_with' },
};
